import React from "react";
import { observer } from "mobx-react";
import { AiSearchConversationViewStore } from "../../store";
import { AiSearchConversationViewForm } from "./AiSearchConversationViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AiSearchConversationViewProps = {
  aiSearchConversationViewStore: AiSearchConversationViewStore;
};

export const AiSearchConversationView: React.FC<AiSearchConversationViewProps> =
  observer(({ aiSearchConversationViewStore }) => {
    return (
      <div>
        <AiSearchConversationViewForm
          startedAt={aiSearchConversationViewStore.startedAtValue}
          lastMessageAt={aiSearchConversationViewStore.lastMessageAtValue}
          messageCount={aiSearchConversationViewStore.messageCountValue}
          messages={aiSearchConversationViewStore.messagesValue}
          context={aiSearchConversationViewStore.contextValue}
          onPrint={(handlePrint: () => void) =>
            aiSearchConversationViewStore.printAiSearchConversation(handlePrint)
          }
          onCancel={() =>
            aiSearchConversationViewStore.cancelAiSearchConversation()
          }
          onEdit={
            aiSearchConversationViewStore.isEditEnabled
              ? () => aiSearchConversationViewStore.editAiSearchConversation()
              : undefined
          }
        />
        <ErrorDialog
          open={aiSearchConversationViewStore.errorDialogOpened}
          title={aiSearchConversationViewStore.errorTitle}
          description={aiSearchConversationViewStore.errorDescription}
          onClose={() => aiSearchConversationViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
